import { Link } from '@mui/joy';
import { useEffect, useState } from 'react';

interface ObfuscatedEmailProps {
  name: string;
  domain?: string;
}

export function ObfuscatedEmail({ name, domain = 'vm.bwl.de' }: ObfuscatedEmailProps) {
  const [resolvedEmail, setResolvedEmail] = useState('');

  const email = `${name}@${domain}`;

  useEffect(() => {
    setResolvedEmail(email);
  }, [email]);

  return <Link href={`mailto:${resolvedEmail}`}>{resolvedEmail || new Array(email.length).fill('-')}</Link>;
}
